import error from "@incigma/shared/apps/youtube.thumbnail.downloader/youtube.thumbnail.downloader.error";
import * as fn from "@incigma/shared/apps/youtube.thumbnail.downloader/youtube.thumbnail.downloader.function";
import * as definitions from "@incigma/shared/apps/youtube.thumbnail.downloader/youtube.thumbnail.downloader.definitions";

export function url(url: string) {
  const runtimeConfig = useRuntimeConfig();

  if (url.startsWith("/") === false) {
    url = `/${url}`;
  }

  const params = { base: runtimeConfig.public.apiUrl, url: url };

  const result = fn.url(params);

  return result;
}

export { error, fn, definitions };
